import { Box, Divider, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import { StationList } from './StationList';

export const AdminStations = () => {
    const navigate = useNavigate();

    const handleCreateStation = () => {
        navigate('/admin/stations/create');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100%',
                height: '100%',
            }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 3, pb: 2 }}>
                <Typography variant="h5">Stations</Typography>
                <Button variant="contained" onClick={handleCreateStation}>
                    Create Station
                </Button>
            </Box>
            <Divider />
            <StationList />
        </Box>
    );
};
